import moment from 'moment';

export const validate = (values) => { // eslint-disable-line
  const errors = {};

  // Inizio limite anno di nascita ammesso anno corrente - 120
  const startYear = moment().format('YYYY') - 120;

  // Fine limite anno di nascita ammesso anno corrente - 16
  const endYear = moment().format('YYYY') - 16;

  const startDate = moment(new Date(startYear, 1, 1)).format('X');
  const endDate = moment(new Date(endYear, 12, 31)).format('X');

  if (values.dataNascita) {
    const currentDate = values.dataNascita.format('X');
    if (+currentDate < +startDate || +currentDate > +endDate) {
      errors.dataNascita = `L' anno di nascita deve essere compreso tra il 1 gennaio ${startYear} e il 31 dicembre ${endYear}`;
    }
  }

  return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./app/components/Forms/Anagrafica/Base/validation.js